export class KVNavyMultiLayerAnnotation {
  structureCategory: string
  defectType: string
  length: string
  width: string
  depth: string
  locationTransverse: string
  locationLongitudinal: string
  locationVertical: string

  constructor() {
    this.structureCategory = ''
    this.defectType = ''
    this.length = ''
    this.width = ''
    this.depth = ''
    this.locationTransverse = ''
    this.locationLongitudinal = ''
    this.locationVertical = ''
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  static fromJSON(json: any): KVNavyMultiLayerAnnotation {
    const annotation = new KVNavyMultiLayerAnnotation()
    if (json.structureCategory !== undefined)
      annotation.structureCategory = json.structureCategory
    if (json.defectType !== undefined) annotation.defectType = json.defectType
    if (json.length !== undefined) annotation.length = json.length
    if (json.width !== undefined) annotation.width = json.width
    if (json.depth !== undefined) annotation.depth = json.depth
    if (json.locationTransverse !== undefined)
      annotation.locationTransverse = json.locationTransverse
    if (json.locationLongitudinal !== undefined)
      annotation.locationLongitudinal = json.locationLongitudinal
    if (json.locationVertical !== undefined)
      annotation.locationVertical = json.locationVertical

    return annotation
  }

  static toJSON(annotation: KVNavyMultiLayerAnnotation): any {
    return {
      structureCategory: annotation.structureCategory,
      defectType: annotation.defectType,
      length: annotation.length,
      width: annotation.width,
      depth: annotation.depth,
      locationTransverse: annotation.locationTransverse,
      locationLongitudinal: annotation.locationLongitudinal,
      locationVertical: annotation.locationVertical,
    }
  }
}
